module.exports = __webpack_public_path__ + "img/right-dialog-mask.0da3aedb.png";